import { Component, Vue } from 'vue-property-decorator';

import { resendAuth0VerificationEmail } from '@/api';
import { logErrors } from '@/shared/utils';

import { supportEmail } from '@/main';

import ComputerHeaderStyle2 from '@/components/computer-header-style-2/computer-header-style-2.component';

import MobileHeader from '@/components/mobile-header/mobile-header.component';
import TabletHeader from '@/components/tablet-header/tablet-header.component';

@Component({
  name: 'verify-email',
  components: {
    ComputerHeaderStyle2,
    MobileHeader,
    TabletHeader,
  },
})
export default class VerifyemailComponent extends Vue {
  public email = JSON.parse(sessionStorage.getItem('auth0User')!).email;
  public message: string = '';

  public isLoading: boolean = false;

  /** Calls Auth0 to resend verification email */
  public async resendEmail() {
    this.isLoading = true;
    this.message = '';
    const { data, error } = await resendAuth0VerificationEmail(this.email);
    if (!error) {
      this.message = 'Verification email has been resent';
    } else {
      if (error.status === 429) {
        this.message = 'Too many requests sent. Please try again later';
      } else {
        this.message = `Something went wrong... please contact us at ${supportEmail}`;
        logErrors(error, 'resendEmail', 'verifyemail');
      }
    }
    this.isLoading = false;
  }
}
